import styled, { css } from "styled-components";
import media from "styled-media-query";

export const MainGrid = styled.section`
  background-color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
  display: grid;
  max-width: 100vw;
  min-height: var(--app-height);
  /* width: 100vw; */
  grid-template-rows: 72px auto;
  grid-template-areas:
    "headerRight"
    "mainContainer";
  height: var(--app-height);

  ${({ open }) =>
    open &&
    css`
      overflow: hidden;
    `}

  ${media.greaterThan("medium")`
    background-color: ${({ theme }) => theme.colors.neutral.gray2};
    height: fit-content;
    row-gap: 30px;
    grid-template-columns: 248px auto;
    grid-template-areas: 
      "sidebar headerRight"
      "sidebar mainContainer";
  `}
`;

export const MainContainer = styled.div`
  grid-area: mainContainer;
  justify-self: center;
  ${({ open }) =>
    open &&
    css`
      max-height: var(--app-height);
    `}

  ${media.greaterThan("medium")`
    padding: 0 25px;
    width: 100%;
  `}
`;
